import { useMutation } from "react-query";
import InternalStudyListService from "@services/internal-study-list-service";
import { InternalTrainingTraineesToProcess } from "@interfaces/store/internal-list-store-types";

export const useTraineesMemberToProcessMutation = () => {
  return useMutation(InternalStudyListService.process);
};
